/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IPharmacy } from 'app/shared/model/pharmacy.model';
import { IPharmacyConsumer } from 'app/shared/model/pharmacy-consumer.model';
import { IGlucoUser } from 'app/shared/model/gluco-user.model';
import { IPharmacyBillPayment } from 'app/shared/model/pharmacy-bill-payment.model';
import { IPharmacyRefundPayment } from 'app/shared/model/pharmacy-refund-payment.model';
import { IClinicalDictionary } from 'app/shared/model/clinical-dictionary.model';
import { IPharmacyBill } from 'app/shared/model/pharmacy-bill.model';
import { CreditType } from 'app/shared/model/enumerations/credit-type.model';
import { ClosureStatus } from 'app/shared/model/enumerations/closure-status.model';
import { PharmacyAddedByType } from 'app/shared/model/enumerations/pharmacy-added-by-type.model';

export interface IPharmacySaleCredit {
  id?: string;
  totalAmount?: number;
  paidAmount?: number;
  pendingAmount?: number;
  creditType?: keyof typeof CreditType;
  addedById?: string | null;
  modifiedById?: string | null;
  closureStatus?: keyof typeof ClosureStatus;
  active?: boolean | null;
  cursor?: number | null;
  timestampentry?: number | null;
  microSec?: number | null;
  lastUpdated?: number | null;
  addedByType?: keyof typeof PharmacyAddedByType | null;
  modifiedByType?: keyof typeof PharmacyAddedByType | null;
  cancelledReason?: string | null;
  billNumber?: string | null;
  amended?: boolean | null;
  preGst?: boolean | null;
  pharmacy?: IPharmacy | null;
  consumer?: IPharmacyConsumer | null;
  patient?: IGlucoUser | null;
  salePayment?: IPharmacyBillPayment | null;
  refundPayment?: IPharmacyRefundPayment | null;
  amendedFrom?: IPharmacySaleCredit | null;
  amendedTo?: IPharmacySaleCredit | null;
  invoiceType?: IClinicalDictionary | null;
  urType?: IClinicalDictionary | null;
  saleBill?: IPharmacyBill | null;
}

export const defaultValue: Readonly<IPharmacySaleCredit> = {
  active: false,
  amended: false,
  preGst: false,
};
